import React from "react";
import "./Copyright.css";
import { Card, Col, Container, Row, Table } from "react-bootstrap";
import { withTranslation } from "react-i18next";

const Copyright = (props) => (
  <Container>
    <Row className="mt-4">
      <Col>
        <Card>
          <Card.Body>
            <h4 className="mb-3">
              {props.t("Copyright.Title")}
            </h4>
            <Table size="sm">
              <thead></thead>
              <tbody>
                <tr>
                  <td><b>CAMPLA-UI</b></td>
                  <td>{window.appUIVersion}</td>
                </tr>
                <tr>
                  <td><b>{props.t("Copyright.Website")}</b></td>
                  <td>
                    <a href="https://campla.ch" target="_blank" rel="noopener noreferrer">campla.ch</a>
                  </td>
                </tr>
              </tbody>
            </Table>
            <br />
            <pre>
              All Rights Reserved
              <br />
              Copyright (c) {new Date().getFullYear()} University of Applied Sciences and Arts Northwestern Switzerland<br />
              <br />
              THE CONTENTS OF THIS PROJECT ARE PROPRIETARY AND CONFIDENTIAL.<br />
              UNAUTHORIZED COPYING, TRANSFERRING OR REPRODUCTION OF THE CONTENTS OF THIS PROJECT, VIA ANY MEDIUM IS STRICTLY PROHIBITED.<br />
              <br />
              The receipt or possession of the source code and/or any parts thereof does not convey or imply any right to use them<br />
              for any purpose other than the purpose for which they were provided to you.<br />
              <br />
              The software is provided "AS IS", without warranty of any kind, express or implied, including but not limited to<br />
              the warranties of merchantability, fitness for a particular purpose and non infringement.<br />
              In no event shall the authors or copyright holders be liable for any claim, damages or other liability,<br />
              whether in an action of contract, tort or otherwise, arising from, out of or in connection with the software<br />
              or the use or other dealings in the software.<br />
              <br />
              The above copyright notice and this permission notice shall be included in all copies or substantial portions of the software.<br />
            </pre>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  </Container>
)

export default withTranslation()(Copyright);
